import { useQuery } from '@tanstack/react-query';
import { axiosLib } from '@/lib/axios';
import { House } from '../types';

interface HousesResponse {
  colocations: House[];
}

const fetchComingSoonHouses = async (limit: number = 6): Promise<HousesResponse> => {
  const { data } = await axiosLib.get<HousesResponse>(`/api/houses/coming_soon`, {
    params: {
      limit,
    },
  });
  return data;
};

export const useComingSoonHouses = (limit: number = 6) => {
  return useQuery({
    queryKey: ['houses', 'coming-soon', limit],
    queryFn: () => fetchComingSoonHouses(limit),
  });
};
